import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateInvoiceNoteModalForm } from 'application/facility-order/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateNewFlowInvoiceNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        super(rootStore, {
            name: 'facility-order-template-invoice-note-modal',
            Form: FacilityOrderTemplateInvoiceNoteModalForm,
            id: facilityOrderTemplate.id,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderTemplate;
                    },
                    update: async() =>{
                        await this.facilityOrderTemplateService.updateInvoiceNote(this.facilityOrderTemplate.id, this.facilityOrderTemplate.secondaryInsuranceVerified);
                    }
                }
            },
            FormClass: FacilityOrderTemplateInvoiceNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplate = facilityOrderTemplate;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.facilityOrderTemplate.secondaryInsuranceVerified = this.form.$("secondaryInsuranceVerified").value;
            this.actions.update();
            await this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.INVOICE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderTemplateNewFlowInvoiceNoteModalStore;
